var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mt-2",attrs:{"fluid":"xxl"}},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',[_c('LegamDataTables',_vm._b({},'LegamDataTables',_vm.$data,false))],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }